<div *ngIf="activeQuestion" [formGroup]="activeQuestion" class="randomized-setting__container">
  <mat-slide-toggle
    [class.border]="showBorder"
    [labelPosition]="'before'"
    [color]="'primary'"
    formControlName="randomizedCardsInd"
    [checked]="activeQuestion.value.randomizedCardsInd"
  >
    Randomized Cards
  </mat-slide-toggle>
</div>
